import moment from 'moment';
import { Link } from 'react-router-dom';
import { Box, Flex, Grid, Image, Text } from 'theme-ui';
import { DATE_FORMAT } from 'app/constants';
import { Markdown } from '../Markdown';
import { useState } from 'react';
import { Icon } from 'assets/Icon';
import { Circle } from '../Circle';
import { ImagePlaceholder } from '../ImagePlaceholder';

export const AnnouncementRowCompact = ({ announcement, sx, canSeeTradeLink, ...props }) => {
    const [ show, setShow ] = useState(false);
    const label = '%show% summary';
    const labelDisplay = label.replaceAll('%show%', show ? 'Hide' : 'Show');
    const announcementTo = canSeeTradeLink ? {pathname: announcement.announcement} : `/companies/${announcement?.company?.slug}`

    return (
        <Grid
            sx={{
                gridTemplateColumns: ['auto', 'auto 24px'],
                gridGap: '12px',
                pt: 3,
                pb: 1,
                borderBottom: '1px solid #D5D9DA',
                color: '#00000A',
                textDecoration: 'none',
                '&::after': { display: 'none' },
                ...sx
            }}
            {...props}
        >
            <Flex sx={{ flexDirection: 'column', gridGap: '5px' }}>
                <Flex sx={{ flexDirection: ['column', 'row'], justifyContent: 'space-between' }}>
                    <Box
                        as={Link}
                        to={announcementTo}
                        target={'_blank'}
                        sx={{
                            position: 'relative',
                            textDecoration: 'none',
                        }}
                    >
                        <Circle size="50px" type="box" sx={{
                            position: 'absolute',
                            top: '0',
                            left: '12px',
                            bg: 'white',
                            zIndex: 10,
                            overflow: 'hidden',
                            boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.1)'
                        }}>
                            <>
                                {announcement?.company?.logo?.sizes?.tiny ? (
                                    <Image src={announcement?.company?.logo?.sizes?.tiny} sx={{ borderRadius: '50%' }} />
                                ) : (
                                    <ImagePlaceholder sx={{
                                        width: '50px',
                                        height: '50px',
                                        borderRadius: '50%'
                                    }} />
                                )}
                            </>
                        </Circle>
                        <Box ml={90}>
                            <Box className="link-title">ASX:{announcement.company?.code} {announcement.label}</Box>
                            <Box sx={{ fontSize: '14px', color: '#6A7175', my: 'auto' }}>
                                {moment.utc(announcement.releaseDate).format(DATE_FORMAT.datetime_format_friendly)}
                            </Box>
                        </Box>
                    </Box>

                    {announcement?.summary ? (
                        <Box sx={sx} {...props}>
                            <Box sx={{ justifyContent: ['center', null], display: ['flex', 'block'], marginTop: ['12px', '0px'] }}>
                                <Link
                                    to="#" 
                                    sx={{ color: 'dark' }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShow(!show)
                                    }}>
                                    {labelDisplay}
                                    <Icon
                                        sx={{
                                            ml: 2,
                                            transform: show ? 'rotate(-180deg)' : 'rotate(0deg)',
                                            transition: 'transform 0.2s 0.1s ease-in-out'
                                        }}
                                        icon="dropdown"
                                        size="10px"
                                    />
                                </Link>
                            </Box>
                        </Box>
                    ) : null}
                </Flex>
                <Text variant="body_large" color="darker" sx={{
                    maxHeight: show ? '1000px' : 0,
                    overflow: 'hidden',
                    display: 'block',
                    transition: 'max-height 0.5s ease-in-out',
                    pt: 2,
                    ml: [0, 76]
                }}>
                    <Box>
                        <Box sx={{ fontSize: '14px', color: '#6A7175' }}>
                            {announcement?.summary?.map((sum, key) => (
                                <Markdown key={`summary${key}`}>
                                    {`- ${sum}`}
                                </Markdown>
                            ))} 
                        </Box>
                    </Box>
                </Text>
            </Flex>
        </Grid>
    );
}
